import gameConfig from "../../engines/configs/gameConfig";
import O1HD from "../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class attention extends cc.Component {


    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    onEnable()
    {
        if(window['tt']&&gameConfig.DOUYIN_YUMAI==1)
        {
            let Platname:string=null
            let self=this;
            window['tt'].getSystemInfo({
                success:(res)=>{
                    Platname = res.appName;
                    if(Platname!="Douyin")
                    {
                        self.node.active=false
                    }
                },
                fail:(res)=>{
                    console.log(`getSystemInfo 调用失败`);
                    self.node.active=false
                },
            });
        }else
        {
            this.node.active=false
        }
    }
    
    OnClickAttention()
    {
        O1HD.getManagers().soundMgr.playSound('anNiu').then();
        if(window['tt'])
        {
             window['tt'].openAwemeUserProfile();
        }
    }

    // update (dt) {}
}
